/** @format */

import $ from "jquery";
import axios from "axios";
import { Empty } from "antd";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import Minimap from "../../../../components/map/Minimap";
import Chart2 from "../../../../components/Charts/Chart2";
import { header } from "../../../../components/api/Header";
import { ExcelPrint } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import { formatTableValue } from "./formatTableValue";

function Dekadalik({ region, regionId, vaqt, itbId, periodTabs, endpoint }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");
  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));

  const [lyear, setLyear] = useState(year);

  useEffect(() => {
    let active = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const requestUrl = endpoint
          ? getEnv('REACT_APP_BASE_URL') + endpoint + "?year=" + year
          : getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/asosiymanbalar/dekadalik?regionId=" +
            regionId +
            "&year=" +
            year +
            "&vaqt=" +
            vaqt;
        const res = await axios.get(requestUrl,
          endpoint ? header() : { ...header(), params: { itbId } });
        if (active) setData(res.data);
      } catch (e) {
        if (!active) return;
        setData([]);
        console.error("Xato:", e);
        alert("Serverga ulanishda xato!");
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchData();
    return () => { active = false; };
  }, [year, regionId, vaqt, itbId, endpoint]);

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  useEffect(() => {
    close();
  }, [regionId, itbId]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const labels = [
    "Yanvar(I)",
    "Yanvar(II)",
    "Yanvar(III)",
    "Fevral(I)",
    "Fevral(II)",
    "Fevral(III)",
    "Mart(I)",
    "Mart(II)",
    "Mart(III)",
    "Aprel(I)",
    "Aprel(II)",
    "Aprel(III)",
    "May(I)",
    "May(II)",
    "May(III)",
    "Iyun(I)",
    "Iyun(II)",
    "Iyun(III)",
    "Iyul(I)",
    "Iyul(II)",
    "Iyul(III)",
    "Avgust(I)",
    "Avgust(II)",
    "Avgust(III)",
    "Sentyabr(I)",
    "Sentyabr(II)",
    "Sentyabr(III)",
    "Oktyabr(I)",
    "Oktyabr(II)",
    "Oktyabr(III)",
    "Noyabr(I)",
    "Noyabr(II)",
    "Noyabr(III)",
    "Dekabr(I)",
    "Dekabr(II)",
    "Dekabr(III)",
  ];

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className="table-box">
        <div className="table-content-top">
          <div className="table-top-left">
            {periodTabs}
          </div>

          <ul className="table-top-right">
            <li>
              <div className="d-flex">
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={lyear}
                  onChange={(e) => setLyear(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className="btn p-0" onClick={() => generatePDF()}>
                <img src={print} alt="404" />
              </button>
            </li>

            <li>
              <button
                className="btn p-0"
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, year, "tblData")
                }
              >
                <img src={excel} alt="404" />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize="80vh" />
        ) : (
          <div id="content">
            <div
              id="tableFlexible"
              style={{ height: selectedRowKeys === "" ? "80vh" : "37vh" }}
            >
              <div ref={conponentPDF} style={{ width: "100%" }}>
                {data.length > 0 ? (
                  <table
                    id="tblData"
                    className="table table-bordered table-style fixedHeader"
                  >
                    <thead className="">
                      <tr>
                        <th rowSpan={2} className="sticky st1">
                          o
                        </th>

                        <th
                          rowSpan={2}
                          className="sticky"
                          style={{ left: "31px" }}
                        >
                          T/R
                        </th>

                        <th
                          rowSpan={2}
                          className="sticky"
                          style={{ left: "71px", width: "250px" }}
                        >
                          Irrigatsiya tizimlari nomi va asosiy suvolish
                          nuqtalari
                        </th>

                        <th
                          rowSpan={2}
                          className="sticky"
                          style={{ left: "368px" }}
                        >
                          O’lchov birligi
                        </th>

                        <th colSpan={3}>Yanvar</th>
                        <th colSpan={3}>Fevral</th>
                        <th colSpan={3}>Mart</th>
                        <th colSpan={3}>Aprel</th>
                        <th colSpan={3}>May</th>
                        <th colSpan={3}>Iyun</th>
                        <th colSpan={3}>Iyul</th>
                        <th colSpan={3}>Avgust</th>
                        <th colSpan={3}>Sentyabr</th>
                        <th colSpan={3}>Oktyabr</th>
                        <th colSpan={3}>Noyabr</th>
                        <th colSpan={3}>Dekabr</th>
                      </tr>

                      <tr>
                        {Array(36)
                          .fill()
                          .map((p, i) => {
                            return <th key={i}>{decade(i)}</th>;
                          })}
                      </tr>
                    </thead>

                    {data.map((d, index) => (
                      <tbody key={index}>
                        <tr className={"tr tr" + index}>
                          <td className="sticky st1 cell">
                            <input type="checkbox" />
                          </td>

                          <td className="sticky cell" style={{ left: "31px" }}>
                            {index + 1}
                          </td>

                          <td
                            onClick={() => chiz(index)}
                            className={
                              d.lat !== "" && d.lan !== ""
                                ? "text-start sticky fix-with cell haslocation"
                                : "text-start sticky fix-with cell"
                            }
                            style={{ left: "71px" }}
                          >
                            {d.manba_nomi}
                          </td>

                          <td
                            onClick={() => chiz(index)}
                            className="text-start sticky cell"
                            style={{ left: "368px" }}
                          >
                            {d.birligi}
                          </td>

                          {d.data
                            ? d.data.map((s, i) => {
                                const display = formatTableValue(s);
                                return (
                                  <td
                                    onClick={() => chiz(index)}
                                    key={i}
                                    className="cell"
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "80px",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {display}
                                  </td>
                                );
                              })
                            : Array(36)
                                .fill()
                                .map((_, i) => (
                                  <td
                                    onClick={() => chiz(index)}
                                    key={i}
                                    className="cell"
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "80px",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  ></td>
                                ))}

                          {/* {d.data
                            ? d.data.map((s, i) => {
                                const val = parseFloat(s);

                                // Oy va dekadani aniqlash
                                const month = Math.floor(i / 3); // 0 → yanvar, 1 → fevral ...
                                const decade = i % 3; // 0 → 1-dekada, 1 → 2-dekada, 2 → 3-dekada

                                // Oydagi kunlar soni
                                const daysInMonth = new Date(
                                  2025,
                                  month + 1,
                                  0
                                ).getDate();

                                // Bo‘linadigan kunlar soni
                                let divisor = 10;
                                if (decade === 2) {
                                  divisor = daysInMonth - 20; // 3-dekada kunlari
                                }

                                // O'rtacha qiymat
                                const avg = !isNaN(val)
                                  ? (val / divisor).toFixed(1)
                                  : "";

                                return (
                                  <td
                                    onClick={() => chiz(index)}
                                    key={i}
                                    className='cell'
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "80px",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}>
                                    {avg}
                                  </td>
                                );
                              })
                            : Array(36)
                                .fill()
                                .map((_, i) => (
                                  <td
                                    onClick={() => chiz(index)}
                                    key={i}
                                    className='cell'
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "80px",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}></td>
                                ))} */}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                ) : (
                  <Empty description="Ma'lumot mavjud emas" />
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className="data-content mt-3 mainpage"
          style={{ position: "relative" }}
        >
          <CloseOutlined
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {(data[selectedRowKeys].lat !== null) &
            (data[selectedRowKeys].lan !== null) ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
                setSelectedData={setSelectedRowKeys}
                onSelectData={() => {}}
              />
            ) : null}
          </Card>

          <Chart2 datas={data[selectedRowKeys]["data"]} labels={labels} />
        </div>
      )}
    </>
  );
}

export default Dekadalik;

const decade = (i) => {
  let s = (i % 3) + 1;
  if (s == 1) return "I";
  if (s == 2) return "II";
  if (s == 3) return "III";
};
